import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";

import { merchantApi } from "@api";
import { ArrowLeftColor, IConClose } from "@components";
import { PATH_HOME } from "@configs";
import { IMemberTier, IRedeemLuckyDraw } from "@interfaces";
import { fetchUser, getLuckyDrawSettings, selectAuth, selectMerchant } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { RenderMeta, formatMessage, useNotify } from "@utils";
import { Skeleton } from "antd";
import { AnimatePresence, LazyMotion, domAnimation, m } from "framer-motion";
import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { formatDateStartEnd } from "src/Utils/dateUtil";
import { DisplayPoints } from "./shared/DisplayPoint";
import { Redeemed } from "./shared/Redeemed";

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentLuckyDraw = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const { warning, error, success } = useNotify();
    const history = useHistory();
    //page props
    const { avatar, fullName, memberTier, isConfirm } = props;
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);

    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [focusIndex, setFocusIndex] = useState<number>(0);
    const [showpage1, setShowPage1] = useState(true);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(false);
    const [showpopuppage, setShowPopupPage] = useState(true);
    const [luckyList, setLuckyList] = useState<any[]>([]);
    const [resultData, setResultData] = useState<any>();
    // const [surveyList, setSurveyList] = useState<ISurvey[]>([]);
    const [isLoading, setIsloading] = useState(true);
    const [viewportHeight, setViewportHeight] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        fetchMission();
        setViewportHeight(window.innerHeight);
        getLuckyDraw();
    }, []);

    const getLuckyDraw = () => {
        // if (!merchant?.luckyDrawDisplaySetting) {
        //     dispatch(getLuckyDrawSettings());
        // }
        dispatch(getLuckyDrawSettings());
    };

    const fetchMission = async () => {
        let res = await merchantApi.getLuckyDrawList({
            limit: 40,
            page: 1,
        });
        if (res.data?.docs?.length > 0) {
            setLuckyList(res?.data.docs);
            setIsloading(false);
        }
    };

    const handleCloseDetail = () => {
        setShowPopup(false);
        closeAllPopup();
    };

    const closeAllPopup = () => {
        setShowPage1(true);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(true);
    };

    const onSlideChange2 = (e: any) => {
        setCurrentIndex(e.activeIndex as number);
    };

    const confirmLuckyDraw = async () => {
        await null;
        UIStore.setState({ isLoading: true });
        try {
            let payload: IRedeemLuckyDraw = {
                objectId: luckyList[focusIndex]?._id,
                status: "ACTIVE",
                type: luckyList[focusIndex]?.type,
                quantity: 1,
            };

            let res = await merchantApi.redeemLuckyDraw(payload);
            setResultData(res.data);
            setShowPage4(false);
            setShowResult(true);
            setShowPopupPage(true);
            dispatch(fetchUser());
        } catch (err: any) {
            if (err.response) {
                error(formatMessage(err.response));
            }
        } finally {
            UIStore.setState({ isLoading: false });
        }
    };

    return (
        <>
            <RenderMeta title={t("meta.luckydraw_page")} />
            <StyledLuckyDraw
                themeColor={themes?.themeColor!}
                bgImg={merchant?.luckyDrawDisplaySetting?.backgroundImage!}
                contentColor={merchant?.luckyDrawDisplaySetting?.textColor!}
                themePageColor={merchant?.luckyDrawDisplaySetting?.themeColor!}
            >
                {/* <StyledLuckyDraw themeColor={themes?.themeColor!}> */}
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            onClick={() => history.push(PATH_HOME)}
                            color={merchant?.luckyDrawDisplaySetting?.themeColor}
                        />
                        {/* <span>{t("page.back")}</span> */}
                    </div>
                    <div className="logo-product">
                        {/* <img src="../images/logo-pet.svg" alt="" /> */}
                    </div>
                    {/* <div className="logo-survey">
                        <img src="../images/logo-survey.svg" alt="" />
                        Survey
                    </div> */}
                </header>
                <div className="layout-main-luckydraw">
                    <div className="title-section">
                        <img
                            className="title-img"
                            src={
                                merchant?.luckyDrawDisplaySetting?.icon ||
                                "../../images/lucky_draw_title.png"
                            }
                            alt=""
                        />
                    </div>
                    <div className="layout-show-luckydraw">
                        {isLoading === false ? (
                            <Skeleton
                                loading={isLoading}
                                active
                                avatar
                                title={{ width: 268 }}
                                paragraph={{ rows: 2, width: [120, 120] }}
                            >
                                <div className="img-luckydraw">
                                    <img
                                        src={luckyList?.[focusIndex]?.imageUrl?.[0] || ""}
                                        alt=""
                                    />
                                </div>
                                <div className="title-luckydraw">
                                    {luckyList?.[focusIndex]?.name}
                                </div>
                                <div className="exp-luckydraw">
                                    {t("page.campaignperiod")} :{" "}
                                    {formatDateStartEnd(
                                        luckyList?.[focusIndex]?.startDate,
                                        luckyList?.[focusIndex]?.endDate
                                    )}
                                </div>
                                <StyledLuckyDrawBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    themePageColor={merchant?.luckyDrawDisplaySetting?.themeColor!}
                                    onClick={() => {
                                        setShowPopup(true);
                                    }}
                                >
                                    {t("page.participate")}
                                </StyledLuckyDrawBtn>
                            </Skeleton>
                        ) : (
                            <>
                                {luckyList?.length === 0 && isLoading ? (
                                    <div className="nodata">
                                        <p>No data</p>
                                    </div>
                                ) : (
                                    <Skeleton
                                        loading={isLoading}
                                        active
                                        avatar
                                        title={{ width: 268 }}
                                        paragraph={{ rows: 2, width: [120, 120] }}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
                <div className="wrapper-slide-luckydraw">
                    <div className="layout-slide-luckydraw">
                        {/* <Skeleton loading={isLoading} title={{ width: 70 }} paragraph={false}> */}
                        <div className="title-slide-luckydraw">{t("page.luckydraw")}</div>
                        {/* </Skeleton> */}
                        {isLoading === false ? (
                            <div className="skeleton-load">
                                <Skeleton
                                    loading={isLoading}
                                    title={false}
                                    paragraph={{ rows: 3, width: 100 }}
                                >
                                    <Swiper
                                        slidesPerView={3.5}
                                        onSlideChange={onSlideChange2}
                                        pagination={true}
                                        freeMode={true}
                                        centeredSlides={true}
                                        centeredSlidesBounds={true}

                                        // slideToClickedSlide={true}
                                    >
                                        {luckyList?.map((mItem: any, mIndex: number) => {
                                            return (
                                                <SwiperSlide
                                                    onClick={() => setFocusIndex(mIndex)}
                                                    key={mIndex}
                                                >
                                                    <div
                                                        className={
                                                            "box-slide-luckydraw " +
                                                            (focusIndex === mIndex && "box-active")
                                                        }
                                                    >
                                                        <div className="img-slide-luckydraw">
                                                            <img
                                                                src={
                                                                    mItem?.imageUrl?.[0] ||
                                                                    "../images/img-slide-luckydraw-01.png"
                                                                }
                                                                alt="imgluckydraw"
                                                            />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </Skeleton>
                            </div>
                        ) : (
                            <>
                                {luckyList?.length === 0 && isLoading ? (
                                    <div className="nodata">
                                        <p>No data</p>
                                    </div>
                                ) : (
                                    <div className="skeleton-load">
                                        <Skeleton
                                            loading={isLoading}
                                            title={false}
                                            paragraph={{ rows: 3, width: 100 }}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </StyledLuckyDraw>

            <LazyMotion features={domAnimation}>
                <AnimatePresence>
                    {isShowPopup && (
                        <>
                            <StyledShowPopup
                                initial={{ y: viewportHeight }}
                                animate={{ y: 0 }}
                                exit={{ y: viewportHeight }}
                                transition={{ type: "spring", stiffness: 100, damping: 20 }}
                                themeColor={themes?.themeColor!}
                                themePageColor={merchant?.luckyDrawDisplaySetting?.themeColor!}
                            >
                                <div className="page-wrapper">
                                    <div className="close" onClick={handleCloseDetail}>
                                        <IConClose width={16} />
                                    </div>
                                    {showpopuppage ? (
                                        <div className="content-layout">
                                            <div className="content">
                                                {showpage1 ? (
                                                    <>
                                                        <div className="header-product">
                                                            <div className="layout-img">
                                                                <div className="img-product">
                                                                    <img
                                                                        src={
                                                                            luckyList?.[focusIndex]
                                                                                ?.imageUrl?.[0] ||
                                                                            "../images/img-detail-mission.png"
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="topic-product">
                                                                {luckyList?.[focusIndex]?.name}
                                                            </div>
                                                            <div className="expier-product">
                                                                <DisplayPoints
                                                                    needIcon={true}
                                                                    suffix={`${
                                                                        luckyList?.[focusIndex]
                                                                            ?.point
                                                                    } ${t("page.points")}`}
                                                                    enable={
                                                                        merchant?.securityConfig
                                                                            ?.isPointDisplay!
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="content-product">
                                                            <div className="topic-detail">
                                                                {t("page.conditions")}
                                                            </div>
                                                            <p
                                                                dangerouslySetInnerHTML={{
                                                                    __html: luckyList?.[focusIndex]
                                                                        ?.description,
                                                                }}
                                                            ></p>
                                                        </div>
                                                        <StyledUsedBtn
                                                            className="btn-redeem"
                                                            themeColor={themes?.themeColor!}
                                                            themePageColor={
                                                                merchant?.luckyDrawDisplaySetting
                                                                    ?.themeColor!
                                                            }
                                                            onClick={() => {
                                                                setShowPage1(false);
                                                                setShowPage4(true);
                                                                setShowPopupPage(false);
                                                            }}
                                                        >
                                                            {t("page.participate")}
                                                        </StyledUsedBtn>
                                                    </>
                                                ) : null}

                                                {showresult && (
                                                    <>
                                                        <div className="content-info">
                                                            <div className="header-product">
                                                                <div className="layout-img">
                                                                    <div className="img-product">
                                                                        <img
                                                                            src={
                                                                                luckyList?.[
                                                                                    focusIndex
                                                                                ]?.imageUrl?.[0] ||
                                                                                "../images/img-sub-luckydraw.png"
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="topic-product">
                                                                    {luckyList?.[focusIndex]?.name}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="action-layout">
                                                            <div className="qr-layout">
                                                                <div className="qr-box">
                                                                    <QRCode
                                                                        value={
                                                                            resultData?.luckydraw
                                                                                ?.ticketCode || ""
                                                                        }
                                                                        size={150}
                                                                    />
                                                                </div>
                                                                <StyledCodeButton
                                                                    mainColor={themes?.themeColor!}
                                                                    themePageColor={
                                                                        merchant
                                                                            ?.luckyDrawDisplaySetting
                                                                            ?.themeColor!
                                                                    }
                                                                >
                                                                    {resultData?.luckydraw
                                                                        ?.ticketCode || "---"}
                                                                </StyledCodeButton>
                                                            </div>
                                                            <p className="redeemed-product">
                                                                <span className="redeemed">
                                                                    <Redeemed color="#336C51" />
                                                                </span>
                                                                REDEEMED
                                                            </p>
                                                            <p className="note">
                                                                {t("page.desLuckydraw")}
                                                            </p>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ) : null}
                                    {showpage4 ? (
                                        <StyledPopupRedeem
                                            themeColor={themes?.themeColor!}
                                            themePageColor={
                                                merchant?.luckyDrawDisplaySetting?.themeColor!
                                            }
                                        >
                                            <div className="box-popupconfirm">
                                                <div className="img-popupconfirm">
                                                    <img
                                                        src={
                                                            merchant?.themes?.basicThemeSetting
                                                                ?.iconGeneral[0]?.image
                                                        }
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="title">
                                                    <div className="text-sub-header">
                                                        {t("page.pleaseconfirm")}
                                                    </div>
                                                </div>
                                                <div className="btn-popupconfirm">
                                                    <StyledUsedBtn
                                                        className="btn-cancel"
                                                        themeColor={themes?.themeColor!}
                                                        themePageColor={
                                                            merchant?.luckyDrawDisplaySetting
                                                                ?.themeColor!
                                                        }
                                                        onClick={() => {
                                                            setShowPage4(false);
                                                            setShowPage1(true);
                                                            setShowPopupPage(true);
                                                        }}
                                                    >
                                                        {t("page.cancel")}
                                                    </StyledUsedBtn>
                                                    <StyledUsedBtn
                                                        className="btn-redeem"
                                                        themeColor={themes?.themeColor!}
                                                        themePageColor={
                                                            merchant?.luckyDrawDisplaySetting
                                                                ?.themeColor!
                                                        }
                                                        onClick={confirmLuckyDraw}
                                                    >
                                                        {t("page.confirm")}
                                                    </StyledUsedBtn>
                                                </div>
                                            </div>
                                        </StyledPopupRedeem>
                                    ) : null}
                                </div>
                            </StyledShowPopup>
                            <BlurBackground
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                            />
                        </>
                    )}
                </AnimatePresence>
            </LazyMotion>
        </>
    );
};

// const StyledLuckyDraw = styled.div<{ themeColor: string }>`
const StyledLuckyDraw = styled.div<{
    themeColor: string;
    bgImg: string;
    contentColor: string;
    themePageColor: string;
}>`
    width: 100%;
    margin: 0 auto;
    padding: 15px;
    height: 100vh;
    overflow: scroll;
    background-color: #fff;
    background-position: center top;
    background-repeat: no-repeat;
    background-image: ${(props) =>
        props?.bgImg !== "" ? `url(${props?.bgImg})` : "../../images/bg-main-mission-02.png"};
    background-size: cover;
    position: relative;
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        span {
            margin-left: 10px;
            color: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : "#fff"};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .layout-main-luckydraw {
        margin-top: 2dvh;
        text-align: center;
        height: calc(-29vh + 100vh);
        padding-bottom: 40px;
        /* padding: 50px 0; */
        overflow: scroll;
        .title-section {
            text-align: center;
            margin-top: 1dvh;
            margin-bottom: 10px;
            .title-img {
                // width: 100%;
                // margin-bottom: 8dvh;
                max-width: 300px;
                max-height: 100px;
            }
        }
        .layout-show-luckydraw {
            width: 100%;
            .ant-skeleton {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 20px;
                border-radius: 10px;
                padding: 12px;
                .ant-skeleton-avatar {
                    width: 312px;
                    height: 312px;
                    margin-bottom: 12px;
                    margin-top: 12px;
                    border-radius: 16px;
                }
                .ant-skeleton-header {
                    padding-right: 0;
                }
                .ant-skeleton-title {
                    width: 268px;
                    margin: 0 auto;
                    height: 10px;
                    border-radius: 16px;
                    margin-bottom: 8px;
                }
                .ant-skeleton-paragraph {
                    text-align: center;
                    width: 100%;
                    display: table;
                    margin: 0 auto;
                    margin-bottom: 12px;
                    li {
                        margin: 0 auto;
                        margin-top: 5px;
                        border-radius: 16px;
                        height: 10px;
                        &:last-child {
                            margin-top: 18px;
                        }
                    }
                }
            }

            .img-luckydraw {
                width: calc(100% - 32px);
                margin: 0 auto;
                margin-bottom: 10px;
                img {
                    max-width: 312px;
                    width: 100%;
                    height: auto;
                    border-radius: 15px;
                }
            }
            .title-luckydraw {
                font-size: 18px;
                line-height: 27px;
                font-weight: 600;
                color: ${(props) =>
                    props?.contentColor !== "" ? `${props?.contentColor}` : "#fff"};
                margin-bottom: 2px;
            }
            .exp-luckydraw {
                font-size: 13px;
                line-height: 17px;
                color: ${(props) =>
                    props?.contentColor !== "" ? `${props?.contentColor}` : "#fff"};
                margin-bottom: 12px;
            }
        }
    }
    .wrapper-slide-luckydraw {
        width: 100%;
        height: auto;
        background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 0;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        overflow: hidden;
        padding: 20px 0;
        .layout-slide-luckydraw {
            position: relaitve;
            padding: 0 0 0 16px;
            .skeleton-load {
                .ant-skeleton {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-bottom: 20px;
                    border-radius: 10px;
                    padding: 12px 0;
                    .ant-skeleton-title {
                        width: 268px;
                        margin: 0 auto;
                        height: 10px;
                        border-radius: 16px;
                        margin-bottom: 8px;
                    }
                    .ant-skeleton-paragraph {
                        text-align: center;
                        width: 100%;
                        display: flex;
                        margin: 0 auto;
                        margin-bottom: 12px;
                        justify-content: flex-start;
                        li {
                            width: 100px;
                            height: 100px;
                            border-radius: 6px;
                            margin-top: 0;
                            margin-right: 16px;
                        }
                    }
                }
                .swiper-container {
                    padding-bottom: 16px;
                }
            }
            .title-slide-luckydraw {
                margin-bottom: 10px;
                font-size: 14px;
                color: #000;
                font-weight: 600;
            }
            .swiper-pagination-bullets {
                bottom: -2px;
            }
            .swiper-pagination .swiper-pagination-bullet {
                margin: 0;
                border-radius: 0;
                width: 16px;
                height: 3px;
                bottom: 0;
                background-color: ${(p) => p.themeColor};
            }
            .swiper-pagination-bullet-active {
                border-radius: 10px;
            }
            /* .swiper-pagination-bullet-active {
                background-color: #336c51 !important;
            } */
            .box-slide-luckydraw {
                width: 100px;
                height: 100px;
                border-radius: 6px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .box-active {
                border: ${(props) =>
                    props?.themePageColor !== ""
                        ? `2px solid ${props?.themePageColor}`
                        : "2px solid #336C51"};
            }
            /* .swiper-slide-active {
                .box-slide-luckydraw {
                    border: 2px solid #336C51;
                }
            } */
        }
    }
`;
const StyledPopupRedeem = styled(m.div)<{ themeColor: string; themePageColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // background-color: ${(p) => p.themeColor};
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
    }
`;

const StyledAlienCode = styled.div<{ mainColor?: string }>`
    display: flex;
    align-items: center;
    column-gap: 10px;
    flex-direction: column;
    margin-bottom: 10px;
    .title {
        margin-bottom: 10px;
    }
    .alien-code-btn {
        color: #c4a363;
        margin-bottom: 16px;
        font-size: 20px;
        font-weight: 500;
        margin: 0;
        width: 100%;
        text-align: center;
        padding: 18px 0;
        background-color: #ddd;
        border-radius: 12px;
        background-image: url(../../images/bg-code.svg);
        background-size: cover;
    }
`;

const StyledCodeButton = styled.div<{ mainColor?: string; themePageColor: string }>`
    position: absolute;
    background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.mainColor}`};
    // background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;

const StyledLuckyDrawBtn = styled.button<{ themeColor: string; themePageColor: string }>`
    padding: 14px 32px;
    color: #fff;
    background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`};
    // background: ${(p) => p.themeColor};
    // background-color: #C4A363;
    border-radius: 14px;
    cursor: pointer;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    border: none;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string; themePageColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`};
    // background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledShowPopup = styled(m.div)<{ themeColor: string; themePageColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    /* background: rgba(0, 0, 0, 0.5); */
    z-index: 10;
    /* left: 50%; */
    /* transform: translateX(-50%); */
    flex-direction: column;
    justify-content: end;
    /* transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    } */
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        /* animation: bottomtotop 0.5s !important;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            cursor: pointer;
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        position: relative;
        /* animation: bottomtotop 0.5s !important;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`};
            // background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: auto;
        min-height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        /* animation: bottomtotop 0.5s !important; */
        /* @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            color: #fff;
            background: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`};
            // background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-top: -100px;
            padding-bottom: 20px;
            .result-luckydraw {
                padding: 12px;
                background-color: rgba(51, 108, 81, 0.08);
                border-radius: 12px;
                position: relative;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .result-img-luckydraw {
                    margin-right: 16px;
                    img {
                        width: 100px;
                        height: 100px;
                    }
                }
                .text-giftset {
                    h2 {
                        font-size: 18px;
                        line-height: 21px;
                        color: #000;
                        font-weight: 600;
                    }
                    p {
                        font-size: 12px;
                        line-height: 16px;
                        margin-bottom: 0;
                        color: #9b9b9b;
                    }
                }
            }
            .layout-img {
                text-align: center;
                .img-product {
                    width: 150px;
                    height: 150px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
            .process-product {
                max-width: 200px;
                margin: 10px auto;
                .ant-progress-inner {
                }
                .ant-progress-bg {
                    background-color: ${(p) => p.themeColor};
                }
            }
        }
        .content-product {
            padding: 16px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            // padding: 10px;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const BlurBackground = styled(m.div)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
`;
